function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M53.84 46.09h4.33a4.15 4.15 0 004.12-4.24V9.44a4.12 4.12 0 00-4.12-4.21H6a4.3 4.3 0 00-4.29 4.21v32.4A4.33 4.33 0 006 46.09h25.3M1.71 12.28h60.58M1.71 20.73h60.58",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.82
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 31.3,
  y: 40.45,
  width: 22.54,
  height: 18.31,
  rx: 1,
  ry: 1,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.82
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.52 33.41a7 7 0 1114.09 0v7H35.52zM5.94 26.36h8.45M17.21 26.36h8.45",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.82
});

function SvgSafePayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+c2FmZS1wYXltZW50PC90aXRsZT48cGF0aCBkPSJNNTMuODQsNDYuMDloNC4zM2E0LjE1LDQuMTUsMCwwLDAsNC4xMi00LjI0VjkuNDRhNC4xMiw0LjEyLDAsMCwwLTQuMTItNC4yMUg2QTQuMyw0LjMsMCwwLDAsMS43MSw5LjQ0djMyLjRBNC4zMyw0LjMzLDAsMCwwLDYsNDYuMDlIMzEuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyLjgyIi8+PGxpbmUgeDE9IjEuNzEiIHkxPSIxMi4yOCIgeDI9IjYyLjI5IiB5Mj0iMTIuMjgiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMi44MiIvPjxsaW5lIHgxPSIxLjcxIiB5MT0iMjAuNzMiIHgyPSI2Mi4yOSIgeTI9IjIwLjczIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIuODIiLz48cmVjdCB4PSIzMS4zIiB5PSI0MC40NSIgd2lkdGg9IjIyLjU0IiBoZWlnaHQ9IjE4LjMxIiByeD0iMSIgcnk9IjEiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMi44MiIvPjxwYXRoIGQ9Ik0zNS41MiwzMy40MWE3LDcsMCwxLDEsMTQuMDksMHY3SDM1LjUyWiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyLjgyIi8+PGxpbmUgeDE9IjUuOTQiIHkxPSIyNi4zNiIgeDI9IjE0LjM5IiB5Mj0iMjYuMzYiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMi44MiIvPjxsaW5lIHgxPSIxNy4yMSIgeTE9IjI2LjM2IiB4Mj0iMjUuNjYiIHkyPSIyNi4zNiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyLjgyIi8+PC9zdmc+";
export { SvgSafePayment as ReactComponent };